import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { TabPanel, TabView } from 'primereact/tabview'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { handleGetRequest } from '../../../services/GetTemplate'
import { useDispatch } from 'react-redux'
import { baseURL } from '../../../Config'
import { io } from 'socket.io-client'
import { handleEncryptData } from '../../../services/EncryptionService'
import { handleDecryptData } from '../../../services/DecryptionService'
import moment from 'moment'
import { getSocket } from '../../../services/Socket'
import { useLocation } from 'react-router-dom'

function Support() {

  const [visible, setVisible] = useState(false)
  const [subjectValue, setSubjectValue] = useState('')
  const [subjectName, setSubjectName] = useState('')
  const [otherSubjectName, setOtherSubjectName] = useState('')
  const [subjectLov, setSubjectLov] = useState([])
  const [openTicketsList, setOpenTicketsList] = useState([])
  const [closeTicketsList, setCloseTicketsList] = useState([])
  const [otherId, setOtherId] = useState('')
  const [activeTab, setActiveTab] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const [page, setPage] = useState(0);

  const newSocket = getSocket();
  const history = useHistory()
  const dispatch = useDispatch()

  const userId = localStorage.getItem('userId')
  const location = useLocation()

  useEffect(() => {
    if (location?.pathname == '/support') {

      localStorage.removeItem('chatTicketId')
      localStorage.removeItem('ticketId')
    }

  }, [location])

  const startSupportChat = () => {
    history.push({
      pathname: './support-chat',
      // state: {
      //   subjectName: subjectName,
      // }
    });
  }

  const getSubjectLov = async () => {
    const response = await dispatch(handleGetRequest(`api/supportSubject/`, true, true));
    const getOtherId = response?.data?.find(item => item?.subject == 'Other')
    setOtherId(getOtherId)
    setSubjectLov(response?.data);
  };

  useEffect(() => {
    getSubjectLov()
  }, [])

  const ViewTicketCard = async (item) => {
    localStorage.setItem('subjectValue', otherSubjectName)
    localStorage.setItem('chatTicketId', item?._id)

    history.push({
      pathname: './support-chat',
      state: {
        chatTicketState: true,
      }
    });
  }

  const handleTabChange = (e) => {

    setActiveTab(e.index);

    const messageData = {
      userId: userId,
      flag: activeTab === 0 ? 'open' : 'close',
      page: page,
    };

    console.log('messageData', messageData)

    const encryptData = handleEncryptData(messageData);
    newSocket.emit('userTickets', JSON.stringify(encryptData), (response) => {
      const decryptedData = handleDecryptData(response?.cipher);
      console.log('decryptedData', decryptedData)

      setOpenTicketsList(decryptedData?.data?.filter(item => item?.status === 'open'));
      setCloseTicketsList(decryptedData?.data?.filter(item => item?.status === 'close'));
    });
  };

  const handleShowMore = () => {

    const messageData = {
      userId: userId,
      flag: activeTab === 0 ? 'open' : 'close',
      page: page + 1,
    };
    setPage(page + 1)

    const encryptData = handleEncryptData(messageData);
    newSocket.emit('userTickets', JSON.stringify(encryptData), (response) => {
      const decryptedData = handleDecryptData(response?.cipher);
      console.log('decryptedData', decryptedData)
      setOpenTicketsList(decryptedData?.data?.filter(item => item?.status === 'open'));
      setCloseTicketsList(decryptedData?.data?.filter(item => item?.status === 'close'));
    });
  };

  console.log('activeTab',activeTab)
  
  useEffect(() => {
    const initialTabData = {
      index: activeTab,
    };
    handleTabChange(initialTabData);
  }, []);

  useEffect(() => {

    if (otherSubjectName) {
      localStorage.setItem('subjectValue', otherSubjectName)
      localStorage.setItem('subjectName', subjectName)
    }
    else if (subjectValue) {
      localStorage.setItem('subjectValue', subjectValue)
      localStorage.setItem('subjectName', subjectName)
    }
    else {
      return null
    }

  }, [subjectValue, otherSubjectName])

  return (
    <>
      <div className='flex justify-content-between align-items-baseline'>
        <h4 className='font-semibold'>Rahper Support</h4>
        <Button className='block ml-auto ' type='button' label='New Chat' icon="pi pi-user" onClick={() => setVisible(true)}></Button>
        <Dialog className='surface-card dialog-card' header="Support" visible={visible} onHide={() => setVisible(false)} >
          <div className='grid'>
            <div className="col-12 mb-3">
              <label className='text-white font-semibold mb-3'>Subject</label>
              <Dropdown
                value={subjectValue}
                placeholder="--Select Subject--"
                options={subjectLov}
                optionLabel="subject"
                optionValue="_id"
                onChange={(e) => {
                  const selectedSubject = e.value;
                  const subjectObject = subjectLov.find(subject => subject._id == selectedSubject);

                  setSubjectValue(selectedSubject);
                  setSubjectName(subjectObject?.subject);
                }}
                className="w-full mt-2"
              />
            </div>

            {subjectValue == otherId?._id && (
              <div className="col-12 mb-3">
                <label className="text-white font-semibold mb-3">Other Subject</label>
                <InputText
                  value={otherSubjectName}
                  placeholder="Enter Other Subject"
                  onChange={(e) => setOtherSubjectName(e.target.value)}
                  className="w-full mt-2"
                />
              </div>
            )}
          </div>
          <Button className='block mx-auto' type='button' label='Continue' onClick={startSupportChat}></Button>
        </Dialog>
      </div>
      <div className="w-max-content border-200 border-3 border-round ">
        <TabView activeIndex={activeTab} onTabChange={handleTabChange} className='p-3'>
          <TabPanel className='grid' header="Active" >
            <div className="col-12 sm:col-6 lg:col-4 border-200 border-2 border-round p-3">
              <div
                style={{
                  maxHeight: '600px', // Adjust as needed
                  overflowY: 'auto',  // Enable scroll
                  paddingRight: '10px',
                }}
              >
                {openTicketsList?.length ?
                  <>
                    {openTicketsList?.slice(0, showMore ? openTicketsList.length : 10)?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="border-200 border-3 p-3 mb-2 tickets-card"
                          style={{ borderRadius: '10px', cursor: 'pointer' }}
                          onClick={() => ViewTicketCard(item)}
                        >
                          <div className="flex justify-content-between align-items-baseline mb-1">
                            <h4>{item?.subject}</h4>
                            <p>{moment(item?.chat[0]?.updatedAt).fromNow()}</p>
                          </div>
                          <p>{item?.chat[0]?.text}</p>
                        </div>
                      );
                    })}
                  </>
                  :
                  <h6 style={{ fontStyle: "italic" }}> No tickets found</h6>
                }
              </div>
              {openTicketsList.length >= 10 && (
                <div>
                  <Button className='block w-full mt-2' type='button' label={showMore ? 'Show Less' : 'Show More'} icon="pi pi-Plus" onClick={handleShowMore}></Button>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel header="Resolved">
            <div className="col-12 sm:col-6 lg:col-4 border-200 border-2 border-round p-3">
              <div
                style={{
                  maxHeight: '600px', // Adjust as needed
                  overflowY: 'auto',  // Enable scroll
                  paddingRight: '10px',
                }}
              >
                {closeTicketsList?.length ?
                  <>
                    {closeTicketsList?.slice(0, showMore ? closeTicketsList.length : 10)?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="border-200 border-3 p-3 mb-2 tickets-card"
                          style={{ borderRadius: '10px', cursor: 'pointer' }}
                          onClick={() => ViewTicketCard(item)}
                        >
                          <div className="flex justify-content-between align-items-baseline mb-1">
                            <h4>{item?.subject}</h4>
                            <p>{moment(item?.chat[0]?.updatedAt).fromNow()}</p>
                          </div>
                          <p>{item?.chat[0]?.text}</p>
                        </div>
                      );
                    })}
                  </>
                  :
                  <h6 style={{ fontStyle: "italic" }}> No tickets found</h6>}
              </div>

              {closeTicketsList.length >= 10 && (
                <div>
                  <Button className='block w-full mt-2' type='button' label={showMore ? 'Show Less' : 'Show More'} icon="pi pi-Plus" onClick={handleShowMore}></Button>
                </div>
              )}
            </div>
          </TabPanel>
        </TabView>
      </div>
    </>

  )
}

export default Support